import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Err404Component } from './components/err404/err404.component';
import { ErrorComponent } from './error.component';

const routes: Routes = [
  {
    path:"",
    component:ErrorComponent, 
    children:[
      {path:"404",component:Err404Component},
      { path: '', redirectTo: '404', pathMatch: 'full' },
      { path: '**', redirectTo: '404', pathMatch: 'full' },
    ]
},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ErrorRoutingModule { }
